export default {
  女装: "لباس زنانه",
  男装: "مردانه",
  手机和小工具: "تلفن های همراه و ابزار",
  居家生活: "زندگی خانگی",
  电脑及周边设备: "کامپیوتر و تجهیزات جانبی",
  美容及个人护理: "زیبایی و مراقبت شخصی",
  家用电器: "لوازم خانگی",
  健康与保健: "سلامتی و تندرستی",
  食品和饮料: "غذا و نوشیدنی",
  玩具_儿童和婴儿: "اسباب بازی ها، بچه ها و نوزادان",
  童装时尚: "مد کودکان",
  视频游戏: "بازی های ویدیویی",
  运动与户外: "ورزش و فضای باز",
  爱好与书籍: "سرگرمی ها و کتاب ها",
  相机和无人机: "دوربین ها و پهپادها",
  宠物食品及用品: "غذا و لوازم حیوانات خانگی",
  女士包袋: "کیف های زنانه",
  男士包袋: "کیف های مردانه",
  珠宝及配饰: "جواهرات و لوازم جانبی",
  手表: "تماشا کردن",
  女鞋: "کفش زنانه",
  男装鞋: "کفش مردانه",
  汽车: "ماشین",
  我附近的ShopeePay: "ShopeePay در نزدیکی من",
  餐饮_旅行和服务: "پذیرایی، مسافرت و خدمات",
  旅行及行李: "سفر و چمدان",
  各种各样的: "انواع مختلف",
  我是来买什么的: "من اینجا هستم که چی بخرم؟",
  对不起_找不到_相关的商品: "با عرض پوزش، هیچ محصولی مرتبط با [{0}] یافت نشد",
  类别: "دسته بندی",
  产品: "تولید - محصول",
  店铺: "فروشگاه",
  首页: "صفحه اول",
  限时秒杀: "فروش فلش به مدت محدود",
  博客: "وبلاگ",
  所有品牌: "همه برندها",
  所有类别: "همه دسته بندی ها",
  我的购物车: "سبد خرید من",
  发货信息: "اطلاعات تحویل",
  交货信息: "اطلاعات تحویل",
  付款: "پرداخت",
  确认: "تایید",
  您的购物车是空的: "سبد خرید شما خالی است",
  价格: "قیمت",
  税: "مالیات",
  数量: "تعداد",
  总计: "جمع",
  移除: "برداشتن",
  返回商店: "بازگشت به فروشگاه",
  继续发货: "به ارسال ادامه دهید",
  筛选: "فیلتر",
  价格范围: "حدود قیمت",
  排序方式: "مرتب سازی بر اساس",
  最新: "به روز",
  最旧: "قدیمی ترین",
  价格从低到高: "قیمت از پایین به بالا",
  价格从高到低: "قیمت از بالا به پایین",
  选择交货类型: "نوع تحویل را انتخاب کنید",
  送货上门: "تحویل",
  继续付款: "به پرداخت ادامه دهید",
  任何其他信息: "هر اطلاعات دیگری",
  或者: "یا",
  您的钱包余额: "موجودی کیف پول شما",
  余额不足: "تعادل ناکافی",
  支付: "پرداخت",
  我同意: "موافقم",
  条款和条件: "شرایط و ضوابط",
  退货政策: "سیاست بازگشت",
  隐私政策: "سیاست حفظ حریم خصوصی",
  概括: "تعمیم دادن",
  项目: "پروژه",
  全部的: "همه",
  小计: "جمع فرعی",
  总运费: "کل هزینه حمل و نقل",
  有优惠码吗_在这里输入: "کد تخفیف داره؟ اینجا وارد کنید",
  申请: "درخواست دادن",
  编辑: "ویرایش کنید",
  删除: "حذف",
  添加新地址: "آدرس جدید اضافه کنید",
  继续交货信息: "اطلاعات تحویل را ادامه دهید",
  选择一个地址: "آدرسی را انتخاب کنید",
  购买历史: "سابقه خرید",
  下载: "دانلود",
  已发送退款请求: "درخواست بازپرداخت ارسال شد",
  对比: "مقایسه کرد",
  对话: "گفتگو",
  我的钱包: "کیف من",
  工单: "سفارش کار",
  管理个人资料: "مدیریت نمایه",
  登出: "خروج از سیستم",
  重置对比列表: "بازنشانی لیست مقایسه",
  您的对比列表为空: "لیست مقایسه شما خالی است",
  在您的购物车中: "در سبد خرید شما",
  在您的愿望清单中: "در لیست آرزوهای شما",
  在您的预定列表中: "در لیست رزرو شما",
  下载您的产品: "محصول خود را دانلود کنید",
  选项: "گزینه ها",
  什么都没找到: "چیزی پیدا نشد",
  特色产品: "محصولات ویژه",
  最畅销: "کتاب پرفروش",
  前_名: "{0} برتر",
  查看更多: "بیشتر ببین",
  查看所有类别: "مشاهده همه دسته ها",
  十大品牌: "ده برند برتر",
  查看所有品牌: "مشاهده همه برندها",
  登录: "وارد شدن",
  手机号码: "شماره تلفن",
  密码: "کلمه عبور",
  密码长度为6到16个字符: "طول رمز عبور 6 تا 16 کاراکتر است",
  验证码: "کد تایید",
  登录中: "وارد شدن",
  游客登录: "ورود بازدید کننده",
  注册您的商店: "فروشگاه خود را ثبت کنید",
  现在申请: "اکنون درخواست دهید",
  成为商家: "تاجر شوید",
  现在注册: "همین الان ثبت نام کنید",
  登录成功: "با موفقیت فرود آمد",
  通知: "اعلام کردن",
  未找到通知: "اعلان پیدا نشد",
  评论: "اظهار نظر",
  估计运输时间: "زمان تخمینی حمل و نقل",
  天: "آسمان",
  所售: "فروخته شد",
  给商家留言: "برای تاجر پیام بگذارید",
  规格: "مشخصات",
  库存: "در انبار",
  总价: "قیمت کل",
  添加到购物车: "به سبد خرید اضافه کنید",
  立即购买: "الان بخرش",
  缺货: "تمام شده",
  添加到愿望清单: "به لیست علاقه مندی ها اضافه کنید",
  加入对比列表: "به لیست مقایسه اضافه کنید",
  退款: "بازپرداخت",
  查看条款: "مشاهده قوانین",
  分享: "اشتراک گذاری",
  描述: "توصیف کردن",
  相关产品: "محصولات مرتبط",
  没有人问过商家: "کسی از بازرگانان نپرسید",
  该产品暂无评论: "هنوز هیچ نظری در مورد این محصول وجود ندارد",
  客户评论: "نظرات مشتریان",
  访问商店: "نمایشگاه",
  畅销产品: "بهترین فروشندگان",
  日期: "تاریخ",
  订单编号: "شماره سفارش",
  总额: "مبلغ یکجا",
  状态: "حالت",
  愿望清单: "لیست علاقه مندیها",
  还没有添加任何东西: "هنوز چیزی اضافه نشده است",
  注册: "ثبت نام",
  邀请码: "کد دعوت",
  请输入邀请码: "لطفا کد دعوت نامه را وارد کنید",
  用户名: "نام کاربری",
  请输入用户名: "لطفا نام کاربری را وارد کنید",
  用户名长度为6_14个字符: "طول نام کاربری 6-14 کاراکتر است",
  昵称: "نام مستعار",
  请输入手机号码: "لطفا شماره تلفن را وارد کنید",
  手机号码格式错误: "فرمت شماره تلفن اشتباه است",
  密码长度为6_16个字符: "طول رمز عبور 6-16 کاراکتر است",
  确认密码: "رمز عبور را تایید کنید",
  请输入确认密码: "لطفا رمز عبور تایید را وارد کنید",
  提款密码: "رمز برداشت",
  请输入提款密码: "لطفا رمز برداشت را وارد کنید",
  提款密码长度为4_16个字符: "طول رمز عبور 4-16 کاراکتر است",
  请输入验证码: "لطفا کد تایید را وارد کنید",
  在_s后发送: "بعد از {0} ثانیه ارسال شد",
  发送验证码: "کد تایید را ارسال کنید",
  注册即表示您同意我们的条款和条件:
    "با ثبت نام، شما با شرایط و ضوابط ما موافقت می کنید.",
  创建账号: "یک حساب کاربری ایجاد کنید",
  验证码发送成功: "کد تأیید با موفقیت ارسال شد",
  确认密码不一致: "تأیید کنید که رمز عبور ناسازگار است",
  提款密码必须为数字: "رمز برداشت باید عددی باشد",
  注册成功: "موفقیت ثبت نام",
  购物车: "سبد خرید",
  账户: "حساب",
  我的账户: "حساب من",
  已经有一个账户: "قبلاً یک حساب کاربری دارید",
  新地址: "آدرس جدید",
  编辑地址: "آدرس را ویرایش کنید",
  保存: "صرفه جویی",
  是否默认: "آیا پیش فرض است",
  具体地址: "آدرس مشخص",
  请输入具体地址: "لطفا آدرس خاصی را وارد کنید",
  地区: "حوزه",
  请输入地区: "لطفا منطقه را وارد کنید",
  城市: "شهر",
  请输入城市: "لطفا شهر را وارد کنید",
  省份: "استان",
  请输入省份: "لطفا استان را وارد کنید",
  邮政编码: "کد پستی",
  请输入邮政编码: "لطفا کد پستی را وارد کنید",
  电话号码: "شماره تلفن",
  请输入电话号码: "لطفا شماره تلفن خود را وارد کنید",
  收货人: "گیرنده",
  请输入收货人: "لطفاً گیرنده را وارد کنید",
  保存成功: "با موفقیت ذخیره شد",
  最畅销的商家: "پرفروش ترین بازرگانان",
  查看所有的商家: "مشاهده همه مشاغل",
  支持政策: "سیاست پشتیبانی",
  您的电子邮件地址: "آدرس ایمیل شما",
  订阅: "اشتراک، ابونمان",
  联系方式: "اطلاعات تماس",
  地址: "نشانی",
  美国伊利诺伊州霍夫曼庄园: "هافمن استیتز، ایلینوی، ایالات متحده آمریکا",
  快速链接: "لینک های سریع",
  商家政策: "سیاست های بازرگان",
  submit: "ارسال",
  提款银行卡: "کارت بانکی برداشت",
  我的面板: "پنل من",
  提示: "اشاره",
  确定登出吗: "آیا برای خارج شدن مطمئن هستید؟",
  确定: "مطمئن",
  取消: "لغو کنید",
  项目添加到您的购物车: "کالا را به سبد خرید خود اضافه کنید",
  经常一起购买: "اغلب با هم خرید کنید",
  返回购物: "بازگشت به خرید",
  进行结算: "اقدام به پرداخت",
  帮助热线: "خط کمک",
  查看所有通知: "مشاهده تمام اعلان ها",
  请输入密码: "لطفا رمز عبور را وارد کنید",
  前往充值: "برو به شارژ",
  购物车物品: "اقلام سبد خرید",
  查看购物车: "سبد خرید را بررسی کنید",
  钱包余额: "موجودی کیف پول",
  充值钱包: "شارژ کیف پول",
  钱包充值_线下_: "شارژ کیف پول (آفلاین)",
  申请提款: "برای انصراف اقدام کنید",
  钱包收支明细: "جزئیات درآمد و هزینه کیف پول",
  批准: "تایید",
  提现历史记录: "سابقه برداشت",
  类型: "نوع",
  信息: "اطلاعات",
  付款方式: "روش پرداخت",
  请选择付款方式: "لطفا یک روش پرداخت را انتخاب کنید",
  Bill_Type_RECHARGE_BACK: "شارژ باطن",
  Bill_Type_RECHARGE_ONLINE: "شارژ آنلاین",
  Bill_Type_RECHARGE_REGISTER: "عضویت رایگان",
  Bill_Type_RECHARGE_JACKPOT: "پاداش شارژ مجدد",
  Bill_Type_RECHARGE_PRESENT: "شارژ مجدد پاداش",
  Bill_Type_RECHARGE_FROM_COMMISSION: "انتقال کمیسیون",
  Bill_Type_RECHARGE_TG_COMMISSION: "کمیسیون ارتقاء شارژ",
  Bill_Type_REGISTER_TG_COMMISSION: "کمیسیون ارتقای ثبت نام",
  Bill_Type_WITHDRAW: "کنار کشیدن",
  Bill_Type_WITHDRAW_REJECT: "برداشت رد شد",
  Bill_Type_DEDUCT_HANDLE: "کسر دستی",
  Bill_Type_DEDUCT_RECHARGE_MONEY: "اصلاح شارژ مجدد",
  Bill_Type_MINING_PROFIT: "درآمد معدن",
  Bill_Type_MINING_PROFIT_COMMISSION: "کمیسیون ارتقاء درآمد معدن",
  Bill_Type_VIP_UPGRADE: "ارتقاء VIP",
  Bill_Type_FINANCE_BUY: "محصولات مالی را خریداری کنید",
  Bill_Type_FINANCE_CAPITAL_RETURN: "بازگشت تراز مالی",
  Bill_Type_FINANCE_FEE: "هزینه های مدیریت مالی",
  Bill_Type_FINANCE_PROFIT: "درآمد مدیریت مالی",
  Bill_Type_FINANCE_BUY_COMMISSION: "کمیسیون خرید محصولات مالی",
  Bill_Type_FINANCE_PROFIT_COMMISSION: "کمیسیون درآمد محصول مالی",
  Bill_Type_WHEEL_DRAW: "قرعه کشی چرخ بزرگ",
  Bill_Type_BUY: "خرید کالا",
  Bill_Type_PAY_SHOP: "هزینه حمل و نقل را پرداخت کنید",
  Bill_Type_BUY_COMMISSION: "کمیسیون اقلام خریداری شده",
  Bill_Type_DEPOSIT: "پرداخت سپرده",
  Bill_Type_STORE_BUY: "خرید کالا",
  Bill_Type_STORE_BUY_REFUND: "بازپرداخت محصول را خریداری کنید",
  Bill_Type: "نوع تغییر حساب",
  Before_Money: "مبلغ قبلی",
  Deal_Money: "مبلغ تغییر حساب",
  After_Money: "مقدار بعد",
  Bill_Time: "زمان تغییر حساب",
  No_More_Data: "داده های بیشتری وجود ندارد",
  Apply_Money: "مقدار درخواست",
  Apply_Time: "زمان درخواست",
  Withdraw_Info: "هزینه رسیدگی: {fee}، ورود: {money}",
  提款订单状态_CHECKING: "بررسی در انتظار",
  提款订单状态_TRANSFERRING: "در حال انتقال",
  提款订单状态_PASS: "تایید شده",
  提款订单状态_REJECT: "رد",
  暂无可用充值方式: "هنوز هیچ روش شارژی در دسترس نیست",
  钱包收款码: "کد پرداخت کیف پول",
  钱包地址: "آدرس کیف پول",
  金额限制: "محدودیت مقدار",
  复制: "کپی 🀄",
  付款凭证: "کوپن پرداخت",
  收款银行: "بانک ذینفع",
  收款人: "دریافت کننده وجه",
  收款账号: "شماره حساب پرداخت",
  付款银行: "بانک پرداخت",
  付款人: "پرداخت کننده",
  付款账号: "حساب پرداخت",
  请输入付款银行: "لطفا بانک پرداخت را وارد کنید",
  请输入付款人: "لطفا پرداخت کننده را وارد کنید",
  请输入付款账号: "لطفا شماره حساب پرداخت را وارد کنید",
  请上传付款凭证: "لطفا کوپن پرداخت را آپلود کنید",
  充值金额: "مقدار شارژ مجدد",
  请输入充值金额: "لطفا مبلغ شارژ را وارد کنید",
  submitting: "ارائه ...",
  Confirm: "ارسال",
  Commit_Success: "با موفقیت ثبت شد",
  balanceType_BALANCE: "تعادل",
  balanceType_COMMISSION: "کمیسیون",
  Balance: "موجودی حساب",
  Wash_Money: "موزاییک اضافه کنید",
  请选择银行账户: "لطفا یک حساب بانکی انتخاب کنید",
  卡号类型: "نوع شماره کارت",
  提现金额: "مبلغ برداشت",
  提款金额: "مبلغ برداشت",
  不能为空: "نمیتواند خالی باشد",
  金额不正确: "مقدار نادرست است",
  please_input_withdraw_password: "لطفا رمز برداشت را وارد کنید",
  withdraw_password_format_error: "رمز برداشت باید 4 تا 16 کاراکتر باشد",
  Fee: "کارمزد",
  实际到账: "ورود واقعی",
  交易币种: "ارز معاملاتی",
  原始密码: "رمز اصلی",
  confirm_password_error: "رمز ورود دو بار اشتباه است",
  save_success: "با موفقیت ذخیره شد",
  please_input: "لطفا وارد کنید",
  old_password: "رمز عبور قدیمی",
  new_password: "رمز عبور جدید",
  please_input_confirm_password: "لطفا رمز عبور را دوباره تایید کنید",
  没有找到符合条件的商品: "هیچ محصول منطبقی یافت نشد",
  Search: "جستجو کردن",
  全部: "همه",
  EnumGoodsOrderState_USER_PAY: "در انتظار تحویل",
  EnumGoodsOrderState_SHOP_PAY: "تحویل دادن",
  EnumGoodsOrderState_SUCCESS: "پایان",
  EnumGoodsOrderState_CANCEL: "لغو شد",
  EnumGoodsOrderState_REFUND_SUCCESS: "بازپرداخت شد",
  订单号: "شماره سفارش",
  用户名称: "نام کاربری",
  收益: "درآمد",
  支付时间: "زمان پرداخت",
  配送时间: "زمان تحویل",
  完成时间: "زمان کامل",
  发货: "کشتی",
  全选: "انتخاب همه",
  物品已添加到愿望清单: "مورد به لیست آرزوها اضافه شد",
  物品已添加到比较列表: "مورد به لیست مقایسه اضافه شد",
  购买成功提示: "تبریک می گوییم، خرید شما با موفقیت انجام شد",
  订单列表: "لیست سفارش",
  商品名: "نام محصول",
  图片: "تصویر",
  没有品牌: "بدون مارک",
  基本信息: "اطلاعات اولیه",
  Account_Name: "نام افتتاح حساب",
  Bank_Account: "حساب بانکی",
  Bank_Phone: "رزرو شماره تلفن همراه",
  IFSC: "حساب IFSC",
  UPI: "حساب UPI",
  PIX: "حساب PIX",
  CPF: "حساب CPF",
  GCASH: "حساب GCASH",
  POWWI: "حساب POWWI",
  身份证号: "شماره شناسایی",
  Edit: "تجدید نظر کنید",
  Delete: "حذف",
  Add: "جدید",
  Forget_Withdraw_Password: "رمز برداشت را فراموش کرده اید",
  Bank_Card_Info: "اطلاعات کارت بانکی",
  收款人地址: "آدرس گیرنده پرداخت",
  SWIFT: "سریع",
  Bank_Branch: "نام شعبه",
  分行代码: "کد شعبه",
  银行地址: "آدرس بانک",
  Email: "پست الکترونیک",
  银行卡长度必须超过: "طول کارت بانکی باید از {length} بیشتر باشد",
  银行卡格式不正确: "قالب کارت بانکی نادرست است",
  Do_you_confirm_delete: "تایید حذف؟",
  Please_Login_First: "لطفا ابتدا وارد شوید",
  Bank_Name: "نام بانک",
  Please_add_bank_first:
    "هنوز کارت بانکی خود را قید نکرده‌اید، لطفاً ابتدا آن را اضافه کنید",
  withdrawType: "نوع برداشت",
  withdraw_money_limit:
    "مبلغ برداشت باید بیشتر از 0 و کمتر یا مساوی با {balance} باشد.",
  withdraw_times_limit:
    "شما امروز {todayWithdrawNum} بار برداشت کرده‌اید و هزینه رسیدگی به مبلغ {withdrawFee}% پس از {limitTimes} بار کسر می‌شود. آیا مطمئن هستید که برداشت می کنید؟",
  Copy_Success: "با موفقیت کپی شد",
  商店首页: "صفحه اصلی فروشگاه",
  所有产品: "همه محصولات",
  新到货产品: "محصولات تازه وارد",
  所有商家: "همه بازرگانان",
  请上传: "لطفا آپلود کنید",
  请输入: "لطفا وارد کنید",
  忘记密码: "رمز عبور را فراموش کنید",
  记得我: "مرا به خاطر بسپار",
  共_件: "مجموع {0} مورد",
  取消订单: "لغو سفارش",
  申请退款: "درخواست بازپرداخت",
  未知商家: "تاجر ناشناس",
  到账: "اعلام وصول",
  提款订单状态: "وضعیت سفارش برداشت",
  前_名类别: "{0} دسته برتر",
  取消订单原因_不想要了: "دیگر آن را نخواه",
  取消订单原因_商品错选_多选: "انتخاب اشتباه محصول / انتخاب های متعدد",
  取消订单原因_商品无货: "محصول موجود نیست",
  取消订单原因_地址信息填写错误: "اطلاعات آدرس اشتباه پر شده است",
  取消订单原因_商品降价: "کاهش قیمت محصول",
  取消订单原因_价格高于其他平台: "قیمت بالاتر از سایر پلتفرم ها است",
  取消订单原因_没用_少用_错用优惠:
    "عدم استفاده / استفاده کمتر / سوء استفاده از تخفیف",
  退款原因_拍错_多拍_不喜欢: "عکس اشتباه / ضربه اضافی / آن را دوست ندارم",
  退款原因_商品成分描述不符: "توضیحات ترکیبات محصول مطابقت ندارد",
  退款原因_与商家协商一致退款: "بازپرداخت طبق توافق با تاجر",
  退款原因_生产日期_保质期与商品描述不符:
    "تاریخ تولید / عمر مفید با توضیحات محصول مطابقت ندارد",
  退款原因_图片_产地_批号_规格等描述不符:
    "تصاویر / مبدا مبدا / شماره دسته / مشخصات و سایر توضیحات مطابقت ندارند",
  退款原因_质量问题: "مسائل کیفی",
  退款原因_商品变质_发霉_有异物: "محصول خراب / کپک زده / دارای مواد خارجی است",
  退款原因_少件_含缺少配件_: "چند قطعه (از جمله لوازم جانبی گم شده)",
  退款原因_收到商品时有破损_污渍_变形:
    "مورد در هنگام دریافت آسیب دیده / لکه دار / تغییر شکل داده است.",
  退款原因_假冒品牌: "مارک های تقلبی",
  退款原因_发票问题: "مسائل فاکتور",
  退款原因_商家发错货: "تاجر کالای اشتباهی فرستاد",
  退款原因_预约不到_商家不给退换:
    "نمی توانم قرار ملاقات بگذارم/تاجر برمی گرداند یا مبادله نمی کند",
  退款失败: "بازپرداخت انجام نشد",
  退款处理中: "بازپرداخت در حال انجام است",
  默认: "پیش فرض",
  产品查询: "جستجوی محصول",
  商店LOGO: "لوگوی فروشگاه",
  推广码: "کد تبلیغاتی",
  查看所有: "مشاهده همه",
  确认收货成功: "تایید دریافت کالا با موفقیت",
  物流公司: "شرکت تدارکات",
  物流单号: "شماره محموله",
  发货时间: "زمان ارسال",
  请先选择商品规格: "لطفا ابتدا مشخصات محصول را انتخاب کنید",
  个人信息: "اطلاعات شخصی",
  您的用户名: "نام کاربری شما",
  你的名字: "اسم شما",
  登录名: "نام کاربری",
  你的邮件: "ایمیل شما",
  你的密码: "رمز عبور شما",
  重复输入密码: "تکرار رمز عبور",
  店铺名称: "نام فروشگاه",
  证书类型: "نوع گواهینامه",
  身份证: "کارت شناسایی",
  护照: "گذرنامه",
  驾驶执照: "گواهینامه رانندگی",
  社会保障卡: "کارت امنیت اجتماعی",
  证书正面: "جلوی گواهی",
  证书反面: "سمت عقب گواهی",
  确认收货: "تایید دریافت کالا",
  请选择取消订单的原因必选: "لطفاً دلیل لغو سفارش را انتخاب کنید (الزامی):",
  请选择申请退款的原因必选:
    "لطفاً دلیل درخواست بازپرداخت (الزامی) را انتخاب کنید:",
  留言: "پیام",
  请输入留言: "لطفا یک پیام وارد کنید",
  没有帐户: "بدون حساب",
  钱包充值: "شارژ کیف پول",
  输入您的文字: "متن خود را وارد کنید",
  商家登录: "ورود تاجر",
  有关此产品的任何查询: "هر گونه سوال در مورد این محصول",
  产品名称: "نام محصول",
  你的问题: "مشکل شما",
  白银店铺: "مغازه نقره فروشی",
  铂金店铺: "فروشگاه پلاتین",
  钻石店铺: "الماس فروشی",
  照片: "عکس",
  已退货: "بازگشت",
  邮寄状态: "وضعیت پستی",
  订单摘要: "خلاصه سفارش",
  收件地址: "آدرس گیرنده",
  订购日期: "تاریخ سفارش",
  订单状态: "وضعیت سفارش",
  总订单金额: "مبلغ کل سفارش",
  邮寄方式: "روش ارسال پستی",
  附加信息: "اطلاعات تکمیلی",
  订单详细信息: "جزئیات سفارش",
  交货类型: "نوع تحویل",
  进行评论: "نظر بده",
  已评论: "نظر داد",
  订单金额: "مقدار سفارش",
  优惠券: "کوپن",
  统一运费: "هزینه حمل و نقل ثابت",
  送货地址: "آدرس حمل و نقل",
  评分: "نمره",
  你的意见: "نظر شما",
  匿名: "ناشناس",
  现金: "پول نقد",
  详情: "جزئیات",
  收货地址: "آدرس حمل و نقل",
  暂时没有对话: "هنوز مکالمه ای وجود ندارد",
  你: "شما",
  输入您的回复: "پاسخ خود را وارد کنید",
  删除成功: "با موفقیت حذف شد",
  品牌: "نام تجاری",
  已缴纳的保证金: "سپرده تضمینی پرداخت شده است",
  黄金店铺: "طلافروشی",
  没有更多数据: "داده های بیشتری وجود ندارد",
  站内信: "پیام سایت",
  系统通知: "اطلاع رسانی سیستم",
  邮箱: "ایمیل",
  手机号: "شماره تلفن",
  你的手机号: "شماره تلفن شما",
  营业执照: "مجوز داد و ستد",
  你的邮箱: "صندوق پستی شما",
  搜索结果: "نتایج جستجو",
  系统公告: "اطلاع رسانی سیستم",
  客服: "خدمات مشتری",
  消息已撤回: "پیام برداشته شد",
  物流详情: "جزئیات لجستیک",
  充值: "شارژ کردن",
  提现: "برداشت نقدی",
  信用分: "امتیاز اعتباری",
  余额: "تعادل",
  佣金: "کمیسیون",
  继续购物: "ادامه خرید",
  订单结算: "تسویه سفارش",
  加入对比: "به مقایسه اضافه کنید",
  佣金余额: "تراز کمیسیون",
  刷新: "تازه کردن",
  刷新成功: "بازخوانی با موفقیت انجام شد",
  官网: "وب سایت رسمی",
  税号: "شماره شناسنامه مالیاتی",
  订单: "سفارش دهید",
  合计: "کل",
  系统安全: "امنیت سیستم",
  Recharge_Money_Limit: "مقدار شارژ باید بین {min} و {max} باشد",
  限时优惠: "پیشنهاد زمان محدود",
  高价回收: "بازیافت قیمت بالا",
  姓名: "نام",
  商品订单号: "شماره سفارش محصول",
  商品在线回收: "بازیافت آنلاین محصول",
  提交: "ارسال کنید",
  回收记录: "سوابق بازیافت",
  回收状态: "وضعیت بازیافت",
  回收价格: "قیمت بازیافت",
  纳税码: "کد مالیاتی",
  买家登录: "وارد شوید",
  买家注册: "ثبت نام کنید",
  语言: "波斯语",
  language: "چینی",
  助力提示:
    "کمک به بازرگانان می تواند قرار گرفتن در معرض پلتفرم در فروشگاه های خود را افزایش دهد و هرچه تعداد روزهای تجمعی بیشتر باشد ، قرار گرفتن در معرض بیشتر می شود.",
  已累计助力: "به صورت تجمعی",
  今日已助力: "امروز کمک کرده است",
  立即助力: "بلافاصله کمک کنید",
  商家助力: "کمک بازرگان",
  证件号码: "شماره شناسه",
  证书号码: "شماره گواهینامه"
};
